import * as React from 'react';
import {connect} from 'react-redux';
import {CategorySelector} from "../../../../MyAccount/Listings/EbayListing/ListerField/ListerCategorySelector";
import {ExtendedWrappedFieldProps} from "cl-form/FormFields";
import {formValueSelector} from 'redux-form';

export default (formName) => {
  const publishToEbayForValueSelector = formValueSelector(formName);
  return connect((state) => ({site: publishToEbayForValueSelector(state, 'site')}))
  ((({input, meta: {error, touched}, showErrors, ...props}) => <CategorySelector errorText={showErrors || touched ? error : undefined} {...input} {...props}/>) as React.SFC<ExtendedWrappedFieldProps & { site: string }>);
}
